import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '../../../axios/axiosInstance';
import { EmailVerificationStatusEnum } from '../../model/enum/EmailVerificationStatusEnum.enum';

const key = ['GET_USER_EMAIL_VERIFICATION_STATUS'];

interface UserEmailVerificationStatus {
  status: EmailVerificationStatusEnum;
}

export const useGetUserEmailVerificationStatus = (enabled: boolean) => {
  return useQuery({
    queryKey: [...key],
    queryFn: async (): Promise<UserEmailVerificationStatus> => {
      const { data } = await axiosInstance.get('api/member/email-status/verification');
      return data;
    },
    refetchInterval: (data) => {
      return data?.status === EmailVerificationStatusEnum.Pending ? 5000 : false;
    },
    enabled,
    refetchOnWindowFocus: false
  });
};
